import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  TYPE_AMAZON_PAYMENT_SERVICES,
  TYPE_MOBILPAY,
  TYPE_SHIFT4,
  TYPE_STRIPE,
  TYPE_TWISPAY,
  getPaymentMethodLogo,
} from './getPaymentMethodLogo';
import { PaymentMethod } from './usePaymentMethods';

const paymentProcessorsToBeDisplayedAsCard = [
  TYPE_STRIPE,
  TYPE_MOBILPAY,
  TYPE_TWISPAY,
  TYPE_AMAZON_PAYMENT_SERVICES,
  TYPE_SHIFT4,
];

interface PaymentMethodsProps {
  paymentMethods: PaymentMethod[];
  selectedMethod: number;
  setSelectedMethod: React.Dispatch<React.SetStateAction<number>>;
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({
  paymentMethods,
  selectedMethod,
  setSelectedMethod,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mt-[16px]">
      {paymentMethods.map(({ name, type }, index) => (
        <div
          key={type}
          className={`tab-item p-[16px] ${index === 0 ? 'rounded-t-md' : ''} ${
            (index === paymentMethods.length - 1 &&
              paymentMethods.length > 1) ||
            paymentMethods.length === 1
              ? 'rounded-b-md'
              : ''
          } ${selectedMethod === index && 'checked'}`}
          onClick={() => setSelectedMethod(index)}
        >
          <div className="flex items-center">
            <span className="w-[20px] h-[20px] checkbox-circle"></span>
            <p className="p2-semibold ml-[8px]">
              {paymentProcessorsToBeDisplayedAsCard.includes(type)
                ? t('registrationPage.payWithCard')
                : name}
            </p>
          </div>
          {getPaymentMethodLogo(type) ? (
            <img
              src={getPaymentMethodLogo(type)}
              alt={name}
              className="h-[20px] sm:h-[24px]"
            />
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default PaymentMethods;
